/**
 * Nothing here yet: a quiet glyph, one sentence saying what will be here or
 * when — "Strength history will appear after Q2" — and at most one thing to
 * do about it.
 *
 * Never an apology and never a wall of text: one sentence. The action, when
 * there is one, is the thing that fills the space — "+ Add Flight".
 *
 *   <EmptyState glyph={GAME_GLYPH.route} action={<Button variant="outlined">+ Add Flight</Button>}>
 *     No flights from this airport yet.
 *   </EmptyState>
 */

import type { ReactNode } from 'react';

import { Icon } from './icon';
import type { Glyph } from './glyphs';
import styles from './empty-state.module.css';

interface EmptyStateProps {
  /** A quiet glyph over the sentence, from GLYPH or the game's registry. */
  glyph?: Glyph;
  /** The one sentence. */
  children: ReactNode;
  /** The one thing to do, when there is one. */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ glyph, children, action, className = '' }: EmptyStateProps) {
  return (
    <div className={[styles.empty, className].filter(Boolean).join(' ')}>
      {glyph && <Icon glyph={glyph} size="lg" className={styles.glyph} />}
      <p className={styles.sentence}>{children}</p>
      {action}
    </div>
  );
}
